import React, { FC } from 'react';
import { AppSelect } from '../../../../../components/AppSelect';
import { ComparisonValues } from '../../../types/entities';
import { UpdateRuleBuilderPayload } from '../../CustomRuleBuilder';

const comparisonOptions = Object.values(ComparisonValues)?.map((option) => ({
  value: option,
  title: option,
}));

type Props = {
  name: string;
  ruleId: string;
  handleChange: (values: UpdateRuleBuilderPayload) => void;
  disabled: boolean;
};

export const ComparisonOperator: FC<Props> = ({ name, ruleId, handleChange, disabled }) => {
  return (
    <AppSelect
      disabled={disabled}
      onChange={(values: { value: string }) => handleChange({ value: values.value, ruleId })}
      options={comparisonOptions}
      value={name}
    />
  );
};
